// extracted by mini-css-extract-plugin
export default {"cardField":"ClaimCard_cardField__W2JhU","cardFieldLabel":"ClaimCard_cardFieldLabel__2oaUK"};